import React, { useEffect, useRef } from 'react';
import { StyledButton, SuccessContainer, SuccessMessage, SuccessText } from './success.styles';
import { iconSizes, TickCircleIcon } from '@nebula/icons/ui';
import {
  ChangePaymentMethodStage,
  changePaymentMethodTransition,
  isFlutterApp,
} from '@ecs-uk/web-common-mobile-view-helpers';
import getBilling from '../../../../actions/billing/getBilling';
import { useDispatch } from 'react-redux';

interface CPMSuccessStatusProps {
  toggleHide: () => void;
}

const CPMSuccessMessages = {
  successText: 'Success',
  successMessage: 'Your payment details have been updated',
};

const CPMSuccessStatus: React.FC<CPMSuccessStatusProps> = props => {
  const { toggleHide } = props;
  const successContainerRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    // Refresh billing info to reflect changes
    dispatch(getBilling());

    if (isFlutterApp()) {
      changePaymentMethodTransition({
        stage: ChangePaymentMethodStage.success,
      });
    }

    // Focus on the success container when it mounts for accessibility
    if (successContainerRef.current) {
      successContainerRef.current.focus();
    }
  }, [dispatch, isFlutterApp, changePaymentMethodTransition]);

  const onClickHandler = () => {
    isFlutterApp()
      ? changePaymentMethodTransition({ stage: ChangePaymentMethodStage.successAcknowledged })
      : toggleHide();
  };
  return (
    <SuccessContainer ref={successContainerRef} tabIndex={-1}>
      <TickCircleIcon iconSize={iconSizes.large} />
      <SuccessText>{CPMSuccessMessages.successText}</SuccessText>
      <SuccessMessage>{CPMSuccessMessages.successMessage}</SuccessMessage>
      <StyledButton buttonKind="primaryMagenta" label="Done" onClick={onClickHandler} />
    </SuccessContainer>
  );
};

export default CPMSuccessStatus;
